import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import useNetworkStatus from "../../../_hooks/useNetworkStatus";
import { get_recently_assigned_assessment_kits_list_candidate_action } from "../../../redux/_actions";
import { useDispatch, useSelector } from "react-redux";

const constraints = {
  audio: {
    autoGainControl: false,
    echoCancellation: false,
    noiseSuppression: false,
  },
  video: true,
  echoCancellation: true,
};
function useInterviewInstructions(props) {
  const [interviewStart, setInterviewStart] = useState(false);
  const [permissionAllowed, setPermissionAllowed] = useState(false);
  const [internetStatus, setInternetStatus] = useState(false);
  const [cameraAccess, setCamerAceess] = useState(false);
  const [loadingError, setLoadingError] = useState();
  const [interviewPractice, setInterviewPractice] = useState(true);
  const [appliedJobId, setAppliedJobId] = useState(null);
  const [assignedInterviewKit, setAssignedInterviewKit] = useState(null);
  const [isAllQuestionsNotAnswered, setIsAllQuestionsNotAnswered] =
    useState(true);

  const vidRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { assignedAssessmentKitsListData } = useSelector(
    (state) =>
      state.get_recently_assigned_assessment_kits_list_candidate_reducer
  );

  const networkStatus = useNetworkStatus();

  useEffect(() => {
    getAssignmentKitDetails();
    let url = new URL(window.location.href);
    let interviewKitId = url.searchParams.get("interviewKit");
    let jobId = url.searchParams.get("appliedJob");
    let practiceId = url.searchParams.get("practice");

    if (jobId && interviewKitId) {
      if (practiceId) {
        setInterviewPractice(true);
        setAssignedInterviewKit(practiceId);
      } else {
        setAssignedInterviewKit(interviewKitId);
        setInterviewPractice(false);
      }
      setAppliedJobId(jobId);
    } else {
      setLoadingError("Unable to find the assessment kit you are looking for.");
    }
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    if (navigator.mediaDevices.getUserMedia !== null) {
      setCamerAceess(true);
    }
  }, []);

  useEffect(() => {
    if (!permissionAllowed && cameraAccess)
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          setPermissionAllowed(true);
        })
        .catch((e) => {
          setPermissionAllowed(false);
        });
  }, [cameraAccess, permissionAllowed]);

  // useEffect(() => {
  //   if (cameraAccess && permissionAllowed) callCameraOn();
  // }, [cameraAccess, permissionAllowed]);

  useLayoutEffect(() => {
    const ref = vidRef;
    callCameraOn();
    return function cleanup() {
      stopCamera();
    };
  }, [cameraAccess, permissionAllowed]);

  useEffect(() => {
    setInternetStatus(networkStatus);
  }, [networkStatus]);

  useEffect(() => {
    setInterviewStart(cameraAccess && permissionAllowed && networkStatus);
  }, [cameraAccess, permissionAllowed, networkStatus]);

  useEffect(() => {
    if (
      assignedAssessmentKitsListData &&
      assignedAssessmentKitsListData?.data
    ) {
      let url = new URL(window.location.href);
      let interviewKitId = url.searchParams.get("interviewKit");
      const getCurrentAssignmentKitData =
        assignedAssessmentKitsListData &&
        assignedAssessmentKitsListData?.data.filter(
          (item) => item && item?.interview_kit?.id === Number(interviewKitId)
        );

      if (getCurrentAssignmentKitData && getCurrentAssignmentKitData.length) {
        const abd =
          getCurrentAssignmentKitData?.answered_ques_count ===
          countQuestions(
            getCurrentAssignmentKitData[0]?.interview_kit &&
              getCurrentAssignmentKitData[0].interview_kit?.topics
          );

        setIsAllQuestionsNotAnswered(
          getCurrentAssignmentKitData[0]?.answered_ques_count ===
            countQuestions(
              getCurrentAssignmentKitData[0]?.interview_kit &&
                getCurrentAssignmentKitData[0].interview_kit?.topics
            )
        );
      }
    }
  }, [assignedAssessmentKitsListData]);
  const callCameraOn = () => {
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function (stream) {
        vidRef.current.srcObject = stream;
      })
      .catch((e) => setPermissionAllowed(false));
  };
  const stopCamera = () =>
    vidRef.current &&
    vidRef.current.srcObject &&
    vidRef.current.srcObject.getTracks().forEach((t) => t.stop());

  const onStartClick = () => {
    if (interviewPractice) {
      navigate(
        `/interview?practice=${assignedInterviewKit}&appliedJob=${appliedJobId}`
      );
    } else
      navigate(
        `/interview?interviewKit=${assignedInterviewKit}&appliedJob=${appliedJobId}`
      );
  };
  const getAssignmentKitDetails = async () => {
    const res = await dispatch(
      get_recently_assigned_assessment_kits_list_candidate_action()
    );
  };

  const countQuestions = (data) => {
    let total_question = 0;
    Array.isArray(data) &&
      data.forEach((element) => {
        total_question =
          Array.isArray(element?.questions) &&
          element?.questions &&
          element.questions.length + total_question;
      });
    return total_question;
  };
  return {
    cameraAccess,
    interviewStart,
    internetStatus,
    permissionAllowed,
    vidRef,
    loadingError,
    isAllQuestionsNotAnswered,

    onStartClick,
  };
}

export default useInterviewInstructions;
